'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  Typography,
} from '@musinsa/mds';
import { usePreventBodyScroll } from '../../common/hooks';

interface CouponGuideBottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const GUIDE_ITEMS: ReadonlyArray<string> = [
  '큐레이터가 제공하는 쿠폰은 지정된 상품에 한해, 유효 기간 내 구매 시 적용할 수 있습니다.',
  '동일 쿠폰은 계정당 1회만 발급되며, 중복 사용은 제한됩니다.',
  '큐레이터 쿠폰은 최소 1만 원 이상 구매 시 사용 가능하며, 최대 10만 원까지 할인됩니다.',
];

/**
 * 방문자 쿠폰 적용 상품 페이지에서 EXPIRED 가 아닌 상태일 때 info 아이콘 클릭 시
 * 노출되는 "큐레이터 쿠폰 사용 가이드" 바텀시트.
 */
export const CouponGuideBottomSheet = ({ open, onOpenChange }: CouponGuideBottomSheetProps) => {
  usePreventBodyScroll({ open });

  return (
    <Sheet direction="bottom" open={open} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => onOpenChange(false)}>
          <SheetMotion direction="bottom" className="min-h-[240px]">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer>
                <BottomSheetTitleBox>큐레이터 쿠폰 사용 가이드</BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => onOpenChange(false)}>
                  <IcDelete />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <div className="safe-area-bottom flex flex-col gap-1 bg-white px-4 pt-1 pb-3">
              {GUIDE_ITEMS.map((item) => (
                <div key={item} className="flex items-start gap-1 py-1">
                  <Typography variant="body13pxReg" colorScheme="gray-600">
                    •
                  </Typography>
                  <Typography variant="body13pxReg" colorScheme="gray-600" className="flex-1">
                    {item}
                  </Typography>
                </div>
              ))}
            </div>
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};
